import React, { useEffect, useState } from 'react';
// import { IconSearch } from '../../icons';
import InputMask from 'react-input-mask';

import { Container } from './styles';

interface InputProps extends React.HTMLAttributes<HTMLInputElement> {
    placeholder?: string;
    value: string | any;
    type?: 'text' | 'number';
    mask?: any;
    onChange: (value: any) => void
    search?: boolean;
    className?: any;
    title?: string;
    disabled?: boolean;
}

const InputDefault: React.FC<InputProps> = ({
    placeholder,
    value,
    mask = '',
    onChange,
    type,
    search = false,
    title = null,
    className = '',
    disabled = false,
    ...rest
}) => {
    const [valueInput, setValueInput] = useState<string>(value);

    useEffect(() => {
        setValueInput(value);
    }, [value]);

    function handleOnChange(e: React.FormEvent<HTMLInputElement>) {
        setValueInput(e.currentTarget.value);
        onChange(e.currentTarget.value);
    }

    return (
        <Container className={`form-children-default input ${className}`}>
            {/* {search && <IconSearch />} */}
            {title && <p className="title">{title}</p>}
            <InputMask
                mask={mask}
                type={type}
                value={valueInput}
                onChange={handleOnChange}
                placeholder={placeholder}
                disabled={disabled}
                {...rest}
            />
        </Container>
    );
};

export default InputDefault;